import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {LOG_ENTRIES} from '../../../shared/log-helper/log-helper.service';
import {Log} from 'ng2-logger';
import {DrawerToggleService} from '../../../layout/drawer/drawer-toggle/drawer-toggle.service';

// logger
const log = Log.create(LOG_ENTRIES.home_page.name);
log.color = LOG_ENTRIES.home_page.color;

@Component({
  selector: 'app-homepage',
  templateUrl: './homepage.component.html',
  styleUrls: ['./homepage.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class HomepageComponent implements OnInit {

  drawerDisplay = true;
  menuKeyStr = 'home';

  constructor(private drawerToggleService: DrawerToggleService) {

  }

  ngOnInit() {
    this.drawerToggleService.drawerToggleStatus$.subscribe(
      value => {
        log.info('get drawer toggle status update: ', value);
        this.drawerDisplay = value;
      });
  }
}



// WEBPACK FOOTER //
// /Users/mengxin/Develop/WebProjects/xin-angular/src/app/pages/home/homepage/homepage.component.ts